export const WorkOrder = {
  customerName: "WF Engineering Inc.",
  partName: `OC 15" Disk`,
  partNumber: "P32811",
  quantity: 33,
  trees: 11,
  partsPerTree: 3,
  clusters: 4,
  lotNumber: "998",
  workOrder: "LN-000123-1",
  poNumber: "110352",
  locationName: "IPC - Utah",
  lineItem: "LN-000123",
  startDate: "01/01/2025",
  dueDate: "01/01/2025",
  createdAt: "01/01/2025",
  address: "1156 N 450 W, Lindon UT, 84057",
  freight: "X",
  shipVia: "XPO-COLLECT",
  state: "Wax (In Progress)",
};

export const Data_Objects = [
  { id: 1, label: "Work Orders", data: WorkOrder },
  { id: 2, label: "Purchase Orders", data: WorkOrder },
  { id: 3, label: "Customers", data: WorkOrder },
  { id: 4, label: "Employees", data: WorkOrder },
];

export const getData_Object = (id) => {
  const data = Data_Objects?.find((d) => id === d.id);
  if (!data) return Data_Objects[0].data;
  return data?.data;
};

export const getLabels = (id = 1) => {
  const data = Data_Objects?.find((d) => id === d.id);

  if (!data) return Data_Objects[0].data;
  const keys = Object.keys(data?.data).map((key) => {
    // Split camelCase words
    const words = key.match(/([A-Z]?[a-z]+)/g) || [];

    // Capitalize each word
    const capitalized = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return capitalized;
  });
  keys.unshift("Index");

  return keys;
};

export const Formats = ["Any", "Numbers Only", "Letters Only"]?.map(
  (label, id) => ({ id: id + 1, label }),
);

export const renderTemplate = ({ template, data, index = null, barcode }) => {
  return template.replace(/{{\s*(\w+)\s*}}/g, (match, key) => {
    if (key === "index" && index !== null) {
      return index;
    }
    if (key === "barcode") return barcode;
    return data[key] !== undefined ? data[key] : "";
  });
};
